import { render, staticRenderFns } from "./FieldDateReadOnly.vue?vue&type=template&id=74fc2076&"
import script from "./FieldDateReadOnly.vue?vue&type=script&lang=js&"
export * from "./FieldDateReadOnly.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports